// import moment from 'moment-timezone';

export function isPositiveInteger(variable) {
    if (!isNumber(variable) || !Number.isInteger(variable) || variable <= 0) {
        return false;
    }
    return true;
}
export function isEmptyObject(variable) {
    return isObject(variable) && Object.keys(variable).length === 0;
}
export function isValue(variable) {
    return variable !== undefined && variable !== null;
}
export function isCustomValidJSON(str) {
    if (
        (String(str).startsWith('{') && String(str).endsWith('}')) ||
        (String(str).startsWith('[') && String(str).endsWith(']'))
    ) {
        try {
            const parsed = JSON.parse(str);

            if (typeof parsed === 'object' && parsed !== null) {
                return true;
            }
        } catch (e) {
            return false;
        }
    }
    return false;
}
export function changeFileExtension(filename, newExtension) {
    if (!newExtension.startsWith('.')) {
        newExtension = '.' + newExtension;
    }

    const lastDotIndex = filename.lastIndexOf('.');

    if (lastDotIndex === -1) {
        return filename + newExtension;
    }

    return filename.slice(0, lastDotIndex) + newExtension;
}
export function extractSubstrings(str) {
    const regex = /\{\{(.*?)\}\}/g;
    let matches = [];
    let match;
    while ((match = regex.exec(str)) !== null) {
        matches.push(match[1]);
    }
    return matches;
}
export function removeXMLTags(str) {
    return String(str)?.replace(/<[^>]*>/g, '');
}
export function utenteId() {
    const i = getCurrentInstance();
    if (i) {
        return (i.appContext.config.idPrefix || 'v') + '-' + i.ids[0] + i.ids[1]++;
    } else if (__DEV__) {
        warn(
            `useId() is called when there is no active component ` +
                `instance to be associated with.`
        );
    }
    return '';
}

//CONTROLLO DATI
export function isString(sInput) {
    //Check if sInput is a string. Return Boolean (True or False)
    return sInput && typeof String(sInput) === 'string' && String(sInput) && String(sInput).length
        ? true
        : false;
}
export function isObject(oInput) {
    //Check if sInput is an object and has attributes length. Return Boolean (True or False)
    return oInput && typeof oInput === 'object' && Object.keys(oInput).length ? true : false;
}
export function isNumber(sInput) {
    //Check if sInput is a number. Return Boolean (True or False)
    return sInput &&
        !isNaN(sInput) &&
        isFinite(sInput) &&
        String(sInput || '').length &&
        String(sInput || '').indexOf('e') === -1
        ? true
        : false;
}
export function isArray(oInput) {
    //Check if sInput is an array and has length. Return Boolean (True or False)
    return oInput && typeof oInput === 'object' && oInput.length ? true : false;
}
export function isEmail(sInput) {
    if (isString(sInput)) {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(sInput);
    } else return false;
}
export function isSafeField(sInput) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!?_])[A-Za-z\d@!?_]{8,}$/;
    return regex.test(sInput);
}
export function isCodiceFiscale(sInput) {
    const regex =
        /^(?:[A-Z]{6}[0-9]{2}[A-EHLMPR-T][0-9]{2}[A-Z][0-9]{3}[A-Z]|[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-EHLMPR-T][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z])$/i;
    return regex.test(sInput);
}
export function isPartitaIva(sInput) {
    if (!sInput || sInput.length !== 11 || isNaN(sInput)) return false;

    let s = 0;
    for (let i = 0; i <= 9; i += 2) {
        s += parseInt(sInput.charAt(i));
    }
    for (let i = 1; i <= 9; i += 2) {
        let c = 2 * parseInt(sInput.charAt(i));
        if (c > 9) c = c - 9;
        s += c;
    }
    let checkDigit = (10 - (s % 10)) % 10;
    return checkDigit === parseInt(sInput.charAt(10));
}
export function isPhone(sInput) {
    if (isString(sInput)) {
        const regexInternational = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return regexInternational.test(sInput);
    } else return false;
}

//CONVERSIONE DATI
export function cvString(sInput, defaultVal = '') {
    return sInput && typeof String(sInput) === 'string' && String(sInput) && String(sInput).length
        ? sInput
        : defaultVal;
}
export function cvBool(sInput) {
    //Convert sInput in Boolean
    return String(sInput || '') === '1' || String(sInput || '').toLowerCase() === 'true';
}
export function cvInt(sInput, defaultVal) {
    //Convert sInput in a Integer. Return defaultVal if value is not a parsable
    return String(sInput || '').length && !isNaN(sInput) && isFinite(sInput)
        ? parseInt(sInput)
        : defaultVal;
}
export function cvFloat(sInput, defaultVal) {
    //Convert sInput in a Float. Return defaultVal if value is not a parsable
    return String(sInput || '').length && !isNaN(sInput) && isFinite(sInput)
        ? parseFloat(sInput)
        : defaultVal;
}
export function cvPrice(value, decimals = 2, lang = 'it-IT') {
    return parseFloat(value && !isNaN(value) && isFinite(value) ? value : 0).toLocaleString(lang, {
        minimumFractionDigits: decimals,
    });
}
export function cvDate(date) {
    if (!date) return '-';
    const newDate = new Date(date);
    return newDate.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}
export function cvDateTime(date) {
    if (!date) return '-';
    const newDate = new Date(date);
    return newDate.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}
export async function cvTime(time) {
    if (!time) return '-';

    const [ore, minuti, secondi] = time.split(':');
    return `${ore}:${minuti}`;
}
export function cvArray(array) {
    if (typeof array === 'string') return array.split(',').map((x) => parseInt(x));
    else if (typeof array === 'object' && array.length) return (array || []).join();
    else return '';
}
export function cleanString(string) {
    if (typeof string != 'string') return string;

    return string
        .replace(new RegExp("'", 'g'), "''")
        .replace(new RegExp('[-+^:,;§£€$%&#()"]', 'g'), '')
        .replace(
            /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
            ''
        )
        .trim();
}
export function splitArrayString(array) {
    if (array && array.length) return array;
    else return null;
}

//BROWSER
export function silentChangeUrlParams(objParams) {
    if (!objParams || typeof objParams !== 'object') return;

    const actualUrl = new URL(window.location);

    function flattenObject(obj, parentKey = '', result = {}) {
        for (const key in obj) {
            const value = obj[key];
            const newKey = parentKey ? `${parentKey}_${key}` : key;

            if (
                value !== null &&
                typeof value === 'object' &&
                !Array.isArray(value) &&
                Object.keys(value).length > 0
            ) {
                flattenObject(value, newKey, result);
            } else if (Array.isArray(value) ? value.length > 0 : value !== null && value !== '') {
                result[newKey] = Array.isArray(value) ? JSON.stringify(value) : value;
            }
        }
        return result;
    }

    const flatParams = flattenObject(objParams);

    for (const key of actualUrl.searchParams.keys()) {
        actualUrl.searchParams.delete(key); // clear old params
    }

    for (const key in flatParams) {
        actualUrl.searchParams.set(key, flatParams[key]);
    }

    window.history.replaceState(null, '', actualUrl.toString());
}

// export function silentChangeCalendarParams({ periodo, filtri }) {
//     if (!periodo || !Array.isArray(periodo) || periodo.length !== 2) return;

//     const actualUrl = new URL(window.location);

//     // Set periodo[0] and periodo[1] as timestamp query params
//     // Convert periodo[0] from seconds to milliseconds and format as YYYY-MM-DD
//     const fromDate = new Date(periodo[0] * 1000);
//     const fromDateString = fromDate.toISOString().slice(0, 10); // 'YYYY-MM-DD'
//     actualUrl.searchParams.set('dal', fromDateString);

//     // Convert periodo[1] from seconds to milliseconds and format as YYYY-MM-DD
//     const toDate = new Date(periodo[1] * 1000);
//     const toDateString = toDate.toISOString().slice(0, 10); // 'YYYY-MM-DD'
//     actualUrl.searchParams.set('al', toDateString);

//     // Flatten and set filters
//     if (filtri && typeof filtri === 'object') {
//         for (const [key, value] of Object.entries(filtri)) {
//             if (
//                 value !== null &&
//                 value !== undefined &&
//                 ((typeof value === 'object' && Object.keys(value).length) ||
//                     typeof value !== 'object')
//             ) {
//                 actualUrl.searchParams.set(key, JSON.stringify(value));
//             } else {
//                 actualUrl.searchParams.delete(key);
//             }
//         }
//     }

//     window.history.replaceState(null, '', actualUrl.toString());
// }

export function goTo() {
    const ScrollToRow = document
        .querySelector('.p-datatable-wrapper .p-datatable-table .p-datatable-tbody tr')
        .getBoundingClientRect().top;

    window.scrollTo({
        top: ScrollToRow,
        left: 0,
        behavior: 'smooth',
    });
}
export function findPageName(routePath) {
    const { $localStorage } = useNuxtApp();
    const menu = JSON.parse($localStorage.getItem('menu'));
    if (isArray(menu)) {
        const page = menu.find((x) => x.route === routePath);
        if (isObject(page)) {
            return page.label;
        } else {
            const menuSubPage = (menu.map((x) => x.items || []) || []).flat(Infinity);
            if (isArray(menuSubPage)) {
                const subpage = menuSubPage.find((x) => x.route === routePath);

                if (isObject(subpage)) {
                    return subpage.label;
                } else return '';
            } else return '';
        }
    } else return '';
}

//ALTRO
export async function launchTogether(arrayPromises) {
    // Lancia dei codici simultaneamente e attende il completamento di ognuno di essi prima di restituire i valori
    let _arrayPromises = [];

    for (let myPromise of arrayPromises) {
        _arrayPromises.push(
            new Promise(async (resolve) => {
                resolve(await myPromise);
            })
        );
    }

    return await Promise.all(_arrayPromises);
}
export function isLight(color) {
    //Determina se un colore di sfondo è chiaro o scuro (per poter poi scegliere un text-color appropriato)
    if (color.length == 7) {
        const rgb = [
            parseInt(color.substring(1, 3), 16),
            parseInt(color.substring(3, 5), 16),
            parseInt(color.substring(5), 16),
        ];
        const luminance =
            (0.2126 * rgb[0]) / 255 + (0.7152 * rgb[1]) / 255 + (0.0722 * rgb[2]) / 255;
        return luminance > 0.5;
    }
    return false;
}
export async function onFileChange(image) {
    const formData = new FormData();
    let img;
    for (img of image) {
        formData.append('file', img);
    }
}
export function formatDate(value, defaultValue) {
    if (!value) {
        return defaultValue;
    } else {
        return new Date(value).toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        });
    }
}
export function formatDateWithSeconds(value, defaultValue) {
    if (!value) {
        return defaultValue;
    } else {
        return new Date(value).toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        });
    }
}
export function capitalizeString(sInput) {
    if (sInput && typeof String(sInput) === 'string' && String(sInput) && String(sInput).length) {
        return sInput.charAt(0).toUpperCase() + sInput.slice(1);
    } else {
        return sInput;
    }
}
export async function copiaNegliAppunti(text) {
    const tempInput = document.createElement('textarea');
    tempInput.value = text;

    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);

    document.execCommand('copy');

    document.body.removeChild(tempInput);
}
export async function sortObjectFieldAlphabetically(unordered) {
    const ordered = Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
            obj[key] = unordered[key];
            return obj;
        }, {});

    return JSON.stringify(ordered);
}
export function generatePass(length) {
    const charSets = {
        numbers: '0123456789',
        uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        lowercase: 'abcdefghijklmnopqrstuvwxyz',
        special: '@!?_[]',
    };

    const getRandomChar = (set) => set[Math.floor(Math.random() * set.length)];

    const allSets = [
        () => getRandomChar(charSets.numbers),
        () => getRandomChar(charSets.uppercase),
        () => getRandomChar(charSets.lowercase),
        () => getRandomChar(charSets.special),
    ];

    const generatePassword = () => {
        let pass = '';
        for (let i = 0; i < length; i++) {
            pass += allSets[Math.floor(Math.random() * allSets.length)]();
        }
        return pass;
    };

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!?_\[\]])[A-Za-z\d@!?_\[\]]{8,}$/;
    let pass = generatePassword();
    while (!regex.test(pass)) {
        pass = generatePassword();
    }

    return pass;
}
export function addHexTransparency(hex, percentage) {
    if (!hex) return '';
    else if (!percentage) return hex;
    else if (percentage < 0 || percentage > 100) return hex;
    else {
        const transparencyItems = [
            { percentage: 100, value: 'FF' },
            { percentage: 99, value: 'FC' },
            { percentage: 98, value: 'FA' },
            { percentage: 97, value: 'F7' },
            { percentage: 96, value: 'F5' },
            { percentage: 95, value: 'F2' },
            { percentage: 94, value: 'F0' },
            { percentage: 93, value: 'ED' },
            { percentage: 92, value: 'EB' },
            { percentage: 91, value: 'E8' },
            { percentage: 90, value: 'E6' },
            { percentage: 89, value: 'E3' },
            { percentage: 88, value: 'E0' },
            { percentage: 87, value: 'DE' },
            { percentage: 86, value: 'DB' },
            { percentage: 85, value: 'D9' },
            { percentage: 84, value: 'D6' },
            { percentage: 83, value: 'D4' },
            { percentage: 82, value: 'D1' },
            { percentage: 81, value: 'CF' },
            { percentage: 80, value: 'CC' },
            { percentage: 79, value: 'C9' },
            { percentage: 78, value: 'C7' },
            { percentage: 77, value: 'C4' },
            { percentage: 76, value: 'C2' },
            { percentage: 75, value: 'BF' },
            { percentage: 74, value: 'BD' },
            { percentage: 73, value: 'BA' },
            { percentage: 72, value: 'B8' },
            { percentage: 71, value: 'B5' },
            { percentage: 70, value: 'B3' },
            { percentage: 69, value: 'B0' },
            { percentage: 68, value: 'AD' },
            { percentage: 67, value: 'AB' },
            { percentage: 66, value: 'A8' },
            { percentage: 65, value: 'A6' },
            { percentage: 64, value: 'A3' },
            { percentage: 63, value: 'A1' },
            { percentage: 62, value: '9E' },
            { percentage: 61, value: '9C' },
            { percentage: 60, value: '99' },
            { percentage: 59, value: '96' },
            { percentage: 58, value: '94' },
            { percentage: 57, value: '91' },
            { percentage: 56, value: '8F' },
            { percentage: 55, value: '8C' },
            { percentage: 54, value: '8A' },
            { percentage: 53, value: '87' },
            { percentage: 52, value: '85' },
            { percentage: 51, value: '82' },
            { percentage: 50, value: '80' },
            { percentage: 49, value: '7D' },
            { percentage: 48, value: '7A' },
            { percentage: 47, value: '78' },
            { percentage: 46, value: '75' },
            { percentage: 45, value: '73' },
            { percentage: 44, value: '70' },
            { percentage: 43, value: '6E' },
            { percentage: 42, value: '6B' },
            { percentage: 41, value: '69' },
            { percentage: 40, value: '66' },
            { percentage: 39, value: '63' },
            { percentage: 38, value: '61' },
            { percentage: 37, value: '5E' },
            { percentage: 36, value: '5C' },
            { percentage: 35, value: '59' },
            { percentage: 34, value: '57' },
            { percentage: 33, value: '54' },
            { percentage: 32, value: '52' },
            { percentage: 31, value: '4F' },
            { percentage: 30, value: '4D' },
            { percentage: 29, value: '4A' },
            { percentage: 28, value: '47' },
            { percentage: 27, value: '45' },
            { percentage: 26, value: '42' },
            { percentage: 25, value: '40' },
            { percentage: 24, value: '3D' },
            { percentage: 23, value: '3B' },
            { percentage: 22, value: '38' },
            { percentage: 21, value: '36' },
            { percentage: 20, value: '33' },
            { percentage: 19, value: '30' },
            { percentage: 18, value: '2E' },
            { percentage: 17, value: '2B' },
            { percentage: 16, value: '29' },
            { percentage: 15, value: '26' },
            { percentage: 14, value: '24' },
            { percentage: 13, value: '21' },
            { percentage: 12, value: '1F' },
            { percentage: 11, value: '1C' },
            { percentage: 10, value: '1A' },
            { percentage: 9, value: '17' },
            { percentage: 8, value: '14' },
            { percentage: 7, value: '12' },
            { percentage: 6, value: '0F' },
            { percentage: 5, value: '0D' },
            { percentage: 4, value: '0A' },
            { percentage: 3, value: '08' },
            { percentage: 2, value: '05' },
            { percentage: 1, value: '03' },
            { percentage: 0, value: '00' },
        ];

        return hex + transparencyItems.find((x) => x.percentage == percentage).value;
    }
}
export function returnFirstTableRow() {
    const element = document.getElementsByClassName('p-datatable');

    if (element) {
        const firstRow = element[0]?.querySelector('tr');
        if (firstRow) {
            firstRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
export function saveDialogSetup(detailDialog, route) {
    const pageName = findPageName(route);
    const { $localStorage } = useNuxtApp();

    const exists_dialogs_saved = $localStorage.getItem('dialogs_saved');
    const dialogs_saved = exists_dialogs_saved ? JSON.parse(exists_dialogs_saved) : [];

    if (dialogs_saved.some((dialog) => dialog.pageName === pageName)) {
        const index = dialogs_saved.findIndex((dialog) => dialog.pageName === pageName);
        dialogs_saved[index].detailDialog = JSON.parse(JSON.stringify(detailDialog));
    } else {
        dialogs_saved.push({
            pageName: pageName,
            detailDialog: detailDialog,
        });
    }

    $localStorage.setItem('dialogs_saved', JSON.stringify(dialogs_saved));
}
export function getDialogSetup(route) {
    const pageName = findPageName(route);
    const { $localStorage } = useNuxtApp();

    const exists_dialogs_saved = $localStorage.getItem('dialogs_saved');
    const dialogs_saved = exists_dialogs_saved ? JSON.parse(exists_dialogs_saved) : [];

    if (dialogs_saved.some((dialog) => dialog.pageName === pageName)) {
        const index = dialogs_saved.findIndex((dialog) => dialog.pageName === pageName);
        return dialogs_saved[index].detailDialog;
    } else return null;
}
export function removeDialogSetup(route) {
    const pageName = findPageName(route);
    const { $localStorage } = useNuxtApp();

    const exists_dialogs_saved = $localStorage.getItem('dialogs_saved');
    const dialogs_saved = exists_dialogs_saved ? JSON.parse(exists_dialogs_saved) : [];
    if (dialogs_saved.some((dialog) => dialog.pageName === pageName)) {
        const index = dialogs_saved.findIndex((dialog) => dialog.pageName === pageName);
        dialogs_saved.splice(index, 1);
        $localStorage.setItem('dialogs_saved', JSON.stringify(dialogs_saved));
    }
}
